import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { NecUrl } from '../../model/url/url';

@Injectable()
export class NecTenantAdminAccountInterface {
  constructor(private http: HttpClient) {
  }

  /**
   * æ¯å¦å­å¨è¶ç®¡æé
   * @param userAccountId
   * @param tenantId
   * @returns
   */
  existsUserAccount(userAccountId: number, tenantId: number): Observable<boolean> {
    return this.http.get<boolean>(NecUrl.SERVER_URL + `/server/existsUserAccount?userAccountId=${userAccountId}&tenantId=${tenantId}`);
  }

  /**
   * è·åè¶ç®¡ææç 
   * @param userAccountId
   * @param tenantId
   * @returns
   */
  getAuthCodeByUserAccountId(userAccountId: number, tenantId: number) {
    let params = new HttpParams().set('userAccountId', userAccountId.toString()).set('tenantId', tenantId.toString());
    return this.http.post(NecUrl.SERVER_URL + `/server/tenantAdminAuthCode`, null, {
      responseType: 'text',
      params: params
    });
  }

}
